export enum TemplatesActions {
  RequestForTemplates = 'Request data for templates',
  TemplatesAreAccepted = 'Templates came from API and they\'re stored in store',
  TemplatesAreRejected = 'Cannot fetch templates from API',
  SaveTemplates = 'Save templates',
  RestoreDefault = 'Restore default templates',
}

export enum TemplateSend {
  ToggleTemplateSendModal = 'Toggle modal - send email from templates',
  ToggleTemplateSendModalLoading = 'Toggle send email modal loading',
  OpenTemplateSendModal = 'Open modal after everything was set up',
  SendTemplate = 'Send selected template',
}
